import styled from "styled-components";

export const CardContainer = styled.div`
	box-shadow:
		0px 78px 31px rgba(0, 0, 0, 0.01),
		0px 44px 26px rgba(0, 0, 0, 0.02),
		0px 20px 20px rgba(0, 0, 0, 0.03),
		0px 5px 11px rgba(0, 0, 0, 0.04),
		0px 0px 0px rgba(0, 0, 0, 0.04);
	background: ${({ bgColor }) => bgColor};
	padding: 2rem;
	border-radius: 0.5rem;
`;
